import Blaze from "@swiggy-private/blaze.js";

// helpers
import { Storage } from "@swiggy-private/core-ui";
import { isBusinessLineRegular } from "./Misc";

// types
import { OrderData, isEmpty } from "@swiggy-private/payment-core";
import { PlaceOrderData } from "@swiggy-private/checkout-core";

// constants
import { BLAZE_EVENTS } from "@swiggy-private/checkout-core";
import { SESSION_STORAGE_PAYMENT_LOADED } from "@payment-client/constants/StorageKeys";

export const recordPaymentPercievedTime = (): void => {
    // Record load time metric for single instance in session,
    // record payment load time only for non regular business lines, since regular business line it is recorded in cart-client
    // to prevent falsy metrics be populated which navigating back from history (payments => cart => payments)
    if (!isBusinessLineRegular() && Storage.getItem(SESSION_STORAGE_PAYMENT_LOADED) !== "true") {
        Blaze.recordStart(BLAZE_EVENTS.RECORD_CHECKOUT_PAYMENT_LOAD_TIME);
        Storage.setItem(SESSION_STORAGE_PAYMENT_LOADED, "true");
    }
};

export const buildOrderLoadTimePayload = ({
    orderData,
    orderId,
    placeOrderData,
    isTurboPaymentMethod,
    _isJuspaySdkAvailable,
}: {
    orderData?: OrderData;
    orderId?: string;
    placeOrderData: PlaceOrderData;
    isTurboPaymentMethod: string;
    _isJuspaySdkAvailable: boolean;
}) => {
    let addOrderData = {};
    if (!isEmpty(orderData)) {
        addOrderData = {
            orderPaymentMethod: orderData?.orderPaymentMethod || "",
            orderId: orderId || orderData?.orderId || "",
            paymentGateway: orderData?.paymentTransactions?.[0]?.paymentGateway || "",
        };
    }

    return {
        orderPaymentMethod: placeOrderData?.paymentMethodData?.paymentCode || "",
        paymentMethodCode: placeOrderData?.paymentMethodData?.paymentCode || "",
        isTurboPaymentMethod: isTurboPaymentMethod?.toString() || "",
        isSdkFlow: _isJuspaySdkAvailable?.toString() || "",
        isSplitPay: String(!isEmpty(placeOrderData?.extraParams?.selected_split_pay_amounts || {})),
        isTwidRewards: String(!isEmpty(placeOrderData?.extraParams?.twid_rewards_meta || {})),
        forceValidateCoupon: String(placeOrderData?.extraParams?.force_validate_coupon || false),
        ...addOrderData,
    };
};
